import PreorderProduct from '../../models/PreorderProduct'
import requestAction from '../../utils/requestAction'

export const fetchPreorderProducts = (params: string = "", handleResponse?: (preorderProducts: PreorderProduct[]) => void) => {
  return requestAction('PREORDER_PRODUCT_LIST')(params ? `preorderProducts/${params}` : `preorderProducts`, 'GET',
    undefined, undefined, undefined,
   (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.preoderProducts)}  )
}

export const fetchPreorderSurplusProduct = (params: string = "", handleResponse?: (preorderProducts: PreorderProduct[]) => void) => {
  return requestAction('PREORDER_SURPLUS_PRODUCT')(params ? `preorderProducts/${params}` : `preorderProducts`, 'GET',
    undefined, undefined, undefined,
   (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.preorderProducts)}  )
}

export const fetchAllPreorderProducts = () =>
  fetchPreorderProducts('?all=true')